<div class="message-content">
  <label class="title">{{ title }}</label>
  <label class="message">{{ message }}</label>
</div>
<div class="button-content">
  <label (click)="validated.emit(false)">{{ discard | uppercase }}</label>
  <label (click)="validated.emit(true)">{{ accept | uppercase }}</label>
</div>
